import type * as FormModelType from "@/components/features/cancellation/model/type";

export const cancellationInputModelFactory = (
	hotelID: string,
	defaultBasicBillingTicketID: string | undefined | null,
	defaultProBillingTicketID: string | undefined | null,
	isStopRecurringBasicBilling: boolean,
	isStopRecurringProBilling: boolean,
): FormModelType.CancellationFormModel["InputModel"] =>
	({
		hotelID,
		churnInfo: {
			comment: null,
			reason: "",
			alternativeSystemProductName: null,
			alternativeSystemReason: null,
		},
		defaultBasicBillingTicketID,
		defaultProBillingTicketID,
		isStopRecurringBasicBilling,
		isStopRecurringProBilling,
	}) satisfies FormModelType.CancellationFormModel["InputModel"];
